import { ButtonHTMLAttributes } from "react";
import { useAppSelector } from "store/hooks";
import styles from "./styles.module.css";
import { userSettingState } from "store/selectors";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | "primary"
    | "secondary"
    | "danger"
    | "theme"
    | "green"
    | "green-out";
}

export function Button({
  variant = "primary",
  className = "",
  ...props
}: ButtonProps) {
  const variantStyles = {
    primary: styles.primary,
    secondary: styles.secondary,
    danger: styles.danger,
    theme: styles.theme,
    green: styles.green,
    "green-out": styles["green-out"],
  };
  const { isDarkMode } = useAppSelector(userSettingState);

  const combinedStyles = `${styles.baseStyles} ${variantStyles[variant]} ${
    isDarkMode ? styles.darkMode : ""
  } ${className}   group`;

  return <button className={combinedStyles} {...props} />;
}
